<script>
    import Bar from "svelte-chartjs/src/Bar.svelte";

    export let elementData;

    const chartData = elementData.report;
    const report = elementData.report;
    const chartResult = chartData.chartResult;

    // console.log('ElementChart', 'elementData', elementData, Date.now());
    const largestDataValue = Math.max(
        ...chartResult.series.map((series) =>
            Math.max(...series.points.map((point) => point.y)),
        ),
    );
    const xMin = chartResult.vAxis.hasOwnProperty("min")
        ? chartResult.vAxis.min
        : 0;
    const xMax =
        chartResult.vAxis.hasOwnProperty("max") && chartResult.vAxis.max > 0
            ? chartResult.vAxis.max
            : largestDataValue;
    const inverted = chartResult.combo.hasOwnProperty("inverted")
        ? chartResult.combo.inverted
        : false;

    const baseBackgroundColour = "rgb(109, 160, 194)";
    const baseRGBStart = [109, 160, 194];
    const baseRGBEnd = [10, 60, 94];

    // Create an array of darkening colours from the number of item in chartResult.series
    const datasetsBackgroundColours = Array.from(
        { length: chartResult.series.length },
        (v, i) => {
            // interpolate between baseRGBStart and baseRGBEnd based on length
            const r = Math.floor(
                baseRGBStart[0] -
                    ((baseRGBStart[0] - baseRGBEnd[0]) /
                        chartResult.series.length) *
                        i,
            );
            const g = Math.floor(
                baseRGBStart[1] -
                    ((baseRGBStart[1] - baseRGBEnd[1]) /
                        chartResult.series.length) *
                        i,
            );
            const b = Math.floor(
                baseRGBStart[2] -
                    ((baseRGBStart[2] - baseRGBEnd[2]) /
                        chartResult.series.length) *
                        i,
            );
            const colour = `rgb(${r}, ${g}, ${b})`;
            return colour;
        },
    );

    // console.log('chartResult', chartResult);
    // console.log('datasetsBackgroundColour', datasetsBackgroundColours);
    // console.log('inverted', inverted);

    const datasets = chartResult.series.map((series, index, arrayobj) => {
        return {
            label: series.name,
            data: series.points.map((point) =>
                point.y === null ? 0 : point.y,
            ),
            // indexAxis: inverted ? 'y' : 'x',
            indexAxis: "x",
            maxBarThickness: 40,
            xAxisID: inverted ? "yAxis" : "xAxis",
            yAxisID: inverted ? "xAxis" : "yAxis",
            backgroundColor: datasetsBackgroundColours[index]
                ? datasetsBackgroundColours[index]
                : baseBackgroundColour,
        };
    });

    console.log("datasets", datasets);

    const data = {
        labels: chartResult.categories.map((category) =>
            category.substring(0, 13),
        ),
        datasets: datasets,
    };

    console.log("data", data);

    // const containerWidth = document.querySelector('.element.chart').clientWidth;
    const options = {
        maintainAspectRatio: true,
        // aspectRatio: chartResult.height / 100,
        scales: {
            yAxis: {
                type: "linear",
                min: xMin,
                max: xMax,
                // max: 20,
                offset: false,
                title: {
                    display: true,
                    text: chartResult.vAxis.title,
                },
                grid: {
                    offset: false,
                },
            },
            xAxis: {
                type: "category",
                title: {
                    display: true,
                    text: chartResult.hAxis.title,
                    // padding: 0,
                },
                grid: {
                    drawOnChartArea: false,
                },
                ticks: {
                    autoSkip: false,
                    maxRotation: 90,
                },
            },
        },
        plugins: {
            legend: {
                position: "bottom",
                align: "start",
                labels: {
                    boxWidth: 10,
                    boxHeight: 10,
                    pointStyle: "circle",
                },
            },
            title: {
                display: true,
                // text: chartResult.vAxisSecondary.title,
            },
        },
    };

    if (inverted) {
        // options.scales.xAxis.ticks.maxRotation = 0;
        const newYAxis = options.scales.xAxis;
        options.scales.xAxis = options.scales.yAxis;
        options.scales.yAxis = newYAxis;
    }

    // console.log('ChartData', data, options);
</script>

<div class="element chart">
    {#if report.hasOwnProperty("report") && report.report.type == "chart"}
        {#if chartResult.title}
            <h3>{chartResult.title}</h3>
        {/if}
        <Bar
            {data}
            {options}
            height={chartResult.height ? chartResult.height * 4 : 200}
        />
    {/if}
</div>

<style>
    .chart {
        overflow-x: scroll;
        /* min-height: 400px; */
    }
</style>
